<template>
		<div class="home-page content account-bg" style="height: 100%;">
      <Header></Header>
      <div class="info">
        <div class="back" @click="back" style="margin-top: 0;">
          <img width="70" src="../../static/images/back.png" />
          <span class="fs50 w-title ac">{{$t('profile')}}</span>
        </div>
        <div class="account-top mt50 disflex">
          <div class="at-img ac por">
            <input class="upload-image" type="file" @change="handleFileUpload" accept="image/*">
            <img class="account-img" :src="info.avatar" />
          </div>
          <div class="acct-right">
            <div v-if="isEdit" class="flex" style="margin:20px 0;">
              <input class="fen" style="margin:0px 10px 0 0;width:70%;font-size: 28px;border-radius: 30px;" v-model="nickname" />
              <button class="button" style="width: 30%;padding:5px 20px;" @click="editSub">{{$t('Submit')}}</button>
            </div>
            <div v-else>
              <span class="name-span app-en">{{info.nickname}}</span>
              <span class=" crff1d4f fs33" @click="editName">
                <img width="60" class="edit" src="static/images/edit.png" />
              </span>
            </div>
            <div class="level mt20 disflex">
              <img src="../../static/images/ic4.png">
              <span class="r-line por">
                <label style="text-shadow: rgb(31, 15, 0) 3px 2px 1px;position: absolute;width: 100%;text-align: center;margin: 3px 0 0;">{{info.level_name}}</label>
                <span class="span" :style="'width:'+info.level_process+'%'+';display:inline-block'">
                  <span style="display: inline-block;"></span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="account-content mt50">
          <div class="">
            <div class="fwb">
              <div class="name fw7 ac">
                <img src="static/images/xing.png">
               {{$t('nickname')}}
              </div>
              <div class="fen">
                <span class="fs30">{{info.nickname}}</span>
              </div>
            </div>
            <div class="fwb">
              <div class="name fw7 ac">
                <img src="static/images/phone.png">
               {{$t('phoneNumber')}}
              </div>
              <div class="fen">
                <span class="fs30">{{info.mobile}}</span>
              </div>
            </div>
            <div class="fwb">
              <div class="name fw7 ac">
                <img src="static/images/hd-ic3.png">
                {{$t('TotalCoins')}}
              </div>
              <div class="fen">
                <span class="fs30">{{info.points}}</span>
              </div>
            </div>
            <div class="fwb">
              <div class="name fw7 ac">
                <img src="static/images/hd-ic2.png">
                {{$t('BookAmount')}}
              </div>
              <div class="fen">
                <span class="fs30">{{info.book_num}}</span>
              </div>
            </div>
            <div class="fwb last">
              <div class="name fw7 ac">
                <img src="static/images/hd-ic1.png">
                {{$t('SpinChance')}}
              </div>
              <div class="fen">
                <span class="fs30">{{info.spin_num}}</span>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          isEdit:false,
          info:'',
          nickname:'',
          base64Image:''
        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();

	},
    methods: {
      handleFileUpload(event) {
        let that = this;
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            console.log(e);
            this.base64Image = e.target.result;

            // 从Base64字符串中提取图片类型
            const matches = this.base64Image.match(/^data:image\/([A-Za-z-+/]+);base64,/);
            const type = matches ? matches[1] : '';

            that.uploadImage(type);
          };
          reader.readAsDataURL(file);
        }
      },

      async uploadImage(imageType) {
        let that = this
        if (!this.base64Image) {
          alert('请先选择图片');
          return;
        }
        try {
          let data = {
            image: {
              "content": this.base64Image,
              "type": imageType || "" // 使用提取的类型，如果没有则留空
            }
          }
          that.$parent.loadModal(true);
          that.$api.post('/api/user/upload_avatar', data, r => {
            that.$parent.returnCode(r, function() {
              console.log('上传成功', r.data);
              that.getHome()
              that.$parent.loadModal(false);
            });
          })
        } catch (error) {
          console.error('上传失败', error);
        }
      },
		back(){
			this.$router.go(-1);
		},
    editName(){
      this.isEdit = true
      this.nickname = this.info.nickname
    },
    editSub(){
      let that =this;
      let data = {
        nickname:that.nickname
      }
      //that.$parent.loadModal(true);
      that.$api.post('/api/user/profile',data,r =>{
      	that.$parent.returnCode(r,function(){
      		//that.info = r.data
          that.isEdit = false
          that.getHome()
      		that.$parent.loadModal(false);
        });

      })
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
		},
	}
}
</script>
<style>
  .account-content{background: #4109ac96;border-radius:20px;padding: 20px 40px 20px;border: 1px solid #fff;color:#fff}
  .account-content .fwb{display: flex;color:#fff;border-bottom: 2px solid #fff;align-items: center;justify-content: space-between;padding: 30px 10px;font-size: 34px;}
  .account-content .fwb.last{border-bottom: none;}
  .r-line{background: linear-gradient(to bottom,#3f00bc,#3f00bc,#7011ff);width: 100%;border-radius:20px;}
  .r-line .span{background: #02ee79;text-shadow: 3px 2px 1px #1f0f00;font-size: 30px;padding: 0 20px 0 40px;border-radius: 30px;text-align: right;}
  .acct-right{width: 100%;margin: 0 0 0 20px;color: #fff;}
  .acct-right .level{}
  .acct-right .level img{margin-right: -20px;z-index: 10;}
</style>



// WEBPACK FOOTER //
// src/page/myAccount.vue